<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect3"><span href="#/OEBPS/toc#sect3" title="Link target outside of Sample">Broccoli and Cheddar Quiche with Brown Rice Crust</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/9-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: Serves 6 | Prep Time: 20 minutes | Cook Time: 50 minutes</p>
<p class="extract_r">This brown rice crust is a healthier departure from the typical buttery flaky pastry. The crust recipe could even be repurposed when making pumpkin pie or savory tarts for a fun new twist.</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="rec">2 cups cooked brown rice, cooled (see Notes)</p>
<p class="rec">1¼ cups finely grated cheddar cheese</p>
<p class="rec">¼ cup finely grated Parmesan cheese</p>
<p class="rec">5 large eggs</p>
<p class="rec">½ teaspoon herbes de Provence</p>
<p class="rec">1 pinch nutmeg</p>
<p class="rec">Salt and pepper, to taste</p>
<p class="rec">2 cups broccoli florets, blanched</p>
<p class="rec">6 ounces cremini mushrooms, chopped</p>
<p class="rec">4 scallions, sliced</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. Preheat the oven to 450°F.</p>
<p class="recpr">2. Combine the rice, ¼ cup of the cheddar cheese, the Parmesan cheese, and 1 egg.</p>
<p class="recpr">3. Press the mixture into the bottom and up the sides of a 9-inch pie pan to ¼-inch thickness.</p>
<p class="recpr">4. Bake for 7 minutes until the crust begins to brown.</p>
<p class="recpr">5. In a large bowl, beat the remaining 4 eggs with the herbes de Provence, nutmeg, salt, and pepper.</p>
<p class="recpr">6. After the crust has baked, lower the oven temperature to 375°F.</p>
<p class="recpr">7. Layer the broccoli, mushrooms, remaining 1 cup cheddar cheese, and scallions onto the crust.</p>
<p class="recpr">8. Pour the egg mixture over the vegetables and cheese. Bake for 35 to 40 minutes until set and the top is golden.</p>
<p class="notehead"><strong>NOTES</strong></p>
<p class="NotebText">You’ll need about ⅔ cup uncooked brown rice to yield 2 cups cooked.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect3.vue?0bc3d45f